import React from 'react'
import { FaYoutube , FaIdCard , FaFacebook , FaInstagram , FaTwitter} from 'react-icons/fa'
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap'


const VerificationDetails = ({user}) => {
  console.log(user,"User+++++++++++++++++++")
  return (
    <Row className="justify-content-center mt-4">
    <Col md="12" sm="12">
      <Card className="shadow">
        <CardBody>
          <CardTitle tag="h2" className="">
            Social and Aadhar Information
          </CardTitle>
          
          <Row className="mb-2">
            <Col md="4" sm="4"><FaIdCard /> <strong>Aadhar Number:</strong></Col>
            <Col md="8" sm="8">{user?.buddyDetails?.verificationDetails?.aadharNo}</Col>
          </Row>
          <Row className="mb-2">
            <Col md="4" sm="4"><FaIdCard /> <strong>Aadhar Verification Status:</strong></Col>
            <Col md="8" sm="8">{user?.buddyDetails?.verificationDetails?.aadharVerificationStatus}</Col>
          </Row>
          {/* <Row className="mb-2">
            <Col md="4" sm="4"><FaFacebook color="#4267B2" /> <strong>Facebook:</strong></Col>
            <Col md="8" sm="8">
              <a href={`https://${user?.buddyDetails?.socials?.facebook}`} target="_blank" rel="noopener noreferrer">
                {user?.buddyDetails?.socials?.facebook}
              </a>
            </Col>
          </Row> */}
          <Row className="mb-2">
            <Col md="4" sm="4"><FaInstagram color="#C13584" /> <strong>Instagram:</strong></Col>
            <Col md="8" sm="8">
              <a href={`https://${user?.buddyDetails?.verificationDetails?.instagram}`} target="_blank" rel="noopener noreferrer">
                {user?.buddyDetails?.socials?.instagram}
              </a>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md="4" sm="4"><FaYoutube color="#FF0000" /> <strong>YouTube:</strong></Col>
            <Col md="8" sm="8">
              <a href={`https://${user?.buddyDetails?.verificationDetails?.youtube}`} target="_blank" rel="noopener noreferrer">
                {user?.buddyDetails?.socials?.youtube}
              </a>
            </Col>
          </Row>
          {/* <Row className="mb-2">
            <Col md="4" sm="4"><FaTwitter color="#1DA1F2" /> <strong>X (Twitter):</strong></Col>
            <Col md="8" sm="8">
              <a href={`https://${user?.buddyDetails?.verificationDetails?.twitter}`} target="_blank" rel="noopener noreferrer">
                {user?.buddyDetails?.socials?.twitter}
              </a>
            </Col>
          </Row> */}
          
        </CardBody>
      </Card>
    </Col>
  </Row>
  )
}

export default VerificationDetails